import { faker } from "@faker-js/faker";
import PropTypes from "prop-types";
// material
import { Card, Typography, CardHeader, CardContent } from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineDot,
} from "@mui/lab";
// utils
import { fDateTime, fDateHours } from "../../../utils/formatTime";

// ----------------------------------------------------------------------

const TIMELINES = [
  {
    title: "1983, orders, $4220",
    time: faker.date.past(),
    type: "order1",
  },
  {
    title: "12 Invoices have been paid",
    time: faker.date.past(),
    type: "order2",
  },
  {
    title: "Order #37745 from September",
    time: faker.date.past(),
    type: "order3",
  },
  {
    title: "New order placed #XF-2356",
    time: faker.date.past(),
    type: "order4",
  },
  {
    title: "New order placed #XF-2346",
    time: faker.date.past(),
    type: "order5",
  },
];

// ----------------------------------------------------------------------

OrderItem.propTypes = {
  item: PropTypes.object,
  isLast: PropTypes.bool,
};

function OrderItem({ item, isLast }) {
  const { start, startTime, endTime, title } = item;
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot
          sx={{
            bgcolor: "primary.main",
          }}
        />
        {isLast ? null : <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {start
            ? fDateTime(Date(start))
            : `${startTime.slice(0, -3)} ${!startTime || !endTime ? "" : "-" } ${endTime.slice(0, -3)}`}
        </Typography>
      </TimelineContent>
    </TimelineItem>
  );
}

export default function AppOrderTimeline({ data }) {
  return (
    <Card
      sx={{
        "& .MuiTimelineItem-missingOppositeContent:before": {
          display: "none",
        },
      }}
    >
      <CardHeader title="Today's events" />
      <CardContent>
        <Timeline>
          {typeof data !== "undefined" &&
            data.sort((a, b) => a.startTime.localeCompare(b.startTime)).map((item, index) => (
              <OrderItem
                key={item.title}
                item={item}
                isLast={index === data.length - 1}
              />
            ))}
        </Timeline>
      </CardContent>
    </Card>
  );
}
